export default {
  // report
  LABREPORT: {
    chapter: {
      ___appendix: '付録',
      title: {
        ___main: '本文',
        ___main_subject: '基本項目',
        ___main_insurance: '保險項目解析結果',
        ___main_diagnosis: '表現型関連遺伝子包括検査',
        // ___insurance: '保險項目解析結果',
        // ___disease_diagnosis: '表現型関連遺伝子包括検査',
        ___method: '検査方法',
        ___data_completer: '補足資料',
        ___data_completer_vus: '指定範囲内のVUS（病的意義不明バリアント）',
        ___data_completer_phenotype: '表現型関連網羅的検討',
        ___data_completer_secondary_finding: 'ACMG Secondary Finding 検査'
      },
      header: {
        ___info01: '報告日',
        ___info02: '検查責任者'
      },
      footer: {
      },
      bacis: {
      },
      variantResult: {
      },
      phenorypePanelResult: {
      },
      detectMethod: {
      },
      additionalInfo: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/_labReport/en/lang.js